import { render, staticRenderFns } from "./InquiredAppointmentsPerDaySingle.vue?vue&type=template&id=5852d6fa&"
import script from "./InquiredAppointmentsPerDaySingle.vue?vue&type=script&lang=js&"
export * from "./InquiredAppointmentsPerDaySingle.vue?vue&type=script&lang=js&"
import style0 from "./InquiredAppointmentsPerDaySingle.vue?vue&type=style&index=0&id=5852d6fa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports